/* eslint-disable no-unused-vars */
/* eslint-disable array-bracket-newline */
/**
 * Implement a DEX trading history
 * How-to calculate a price?
 * Imagine pair WBTC/WETH
 * We got 3 coins for 10 coins, so price of 1 BTC is 10 coins / 3 coins
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Image from '../../../atoms/Image';
import history_open from '../../../assets/images/alarm_check.svg';
import history from '../../../assets/images/alarm_check_grey.svg';
import TabMobile from './Tab';
import Trades from '../Trades';
import MyPositions from '../MyPositions';
import TopTraders from '../TopTraders';
import PriceAlerts from '../PriceAlerts';

import './styles.scss';

export enum Tab {
  Trades = 'Trades',
  Positions = 'My Trades',
  TopTraders = 'Top traders',
  PriceAlerts = 'Price alerts',
  None = 'None',
}

const TABS = [Tab.Trades, Tab.Positions, Tab.TopTraders];

const DexTradesMobile = () => {
  const [activeTab, setActive] = useState(Tab.None);
  const chain = useSelector(
    (state: any) => state.current.chain,
    (a, b) => (a == '' && b == '') || (a != '' && b != '')
  );

  useEffect(() => {
    setActive(chain == '' ? Tab.PriceAlerts : Tab.Trades);
  }, [chain]);

  return (
    <div className='dex_trades_mobile'>
      <div className='dex_trades_mobile__tabs'>
        {chain != '' &&
          TABS.map((tab) => (
            <TabMobile
              key={tab}
              tab={tab}
              handleClick={() => setActive(tab)}
              active={activeTab === tab}
            />
          ))}
        <div
          className='dex_trades_mobile__tabs__tab_icon'
          onClick={() => setActive(Tab.PriceAlerts)}
        >
          <Image
            size='m'
            src={activeTab === Tab.PriceAlerts ? history_open : history}
          />
        </div>
      </div>
      {activeTab === Tab.Trades && <Trades isMobile />}
      {activeTab === Tab.Positions && <MyPositions isMobile />}
      {activeTab === Tab.TopTraders && <TopTraders isMobile />}
      {activeTab === Tab.PriceAlerts && <PriceAlerts isMobile />}
    </div>
  );
};

export default DexTradesMobile;
